// extracted by mini-css-extract-plugin
module.exports = {"form":"Landing_form__3cIk9","shorturl":"Landing_shorturl__Slii_","loading":"Landing_loading__7Hdkq"};